module.exports = __webpack_public_path__ + "img/back-top-right.cf979053.png";